/* eslint-disable no-restricted-globals */
import "@/App.less";
import 'antd/dist/antd.css';
import './utils/extends.js'

import apis from "@apis/apis";
import WrapLayout from "@components/wrapLayout/WrapLayout";
import DataStorageUtil from "@utils/storage";
import { parseUrl } from "@utils/utils";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import React, { FC, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Vconsole from 'vconsole'

declare const _hmt: any;
const App: FC = () => {
  const { search } = window.location;
  
  if (search) {
    const urlObj = parseUrl(decodeURI(search));
    const storage: DataStorageUtil = new DataStorageUtil();
    if (urlObj.token) {
      storage.setValue("TOKEN", urlObj.token || "");  
    }
    storage.setValue("appVipType", urlObj.appVipType || "");
    document.title = urlObj?.metaTitle || "点点通";
  }
  useEffect(()=>{
    if (search&&search.includes('vconsole')) {
      // const vConsole = new Vconsole()
    }
    // const vConsole = new Vconsole()
    if (search&&search.includes('from')) {
      const urlObj = parseUrl(decodeURI(search));
      console.log(urlObj.from);
      (window as any)._hmt.push(['_trackEvent', '广告追踪', '访问', urlObj.from]);
    }
    initWx()
  }, [])
  const initWx = ()=>{
    const url = location.href.split('#')[0]
    apis.getWxConfig({
      url
    })?.then((res: any)=>{
      const timestamp = `${res.timestamp}`;
      (window as any).wx.config({
        debug: false,
        appId: res.appId,
        timestamp,
        nonceStr: res.nonceStr,
        signature: res.signature,
        jsApiList: ['updateAppMessageShareData','onMenuShareAppMessage', 'getLocation', 'openLocation'],
        openTagList: ['wx-open-launch-weapp']
      });
      initWxShare()
    })
  }
  const initWxShare = ()=> {
    (window as any).wx.ready(function () {
      if ((window as any).wx.updateAppMessageShareData) {
        (window as any).wx.updateAppMessageShareData({ 
          title: '点点通',
          desc: '让复杂的事情，一点就通',
          link: 'https://ddtonereport.newayz.com/index',
          imgUrl: 'https://media.newayz.com/ddt/bg-map.png'
        })
      }
    });
  }
  return (
    <ConfigProvider locale={zhCN}>
      <div className="app">
        <Router>
          <WrapLayout/>
        </Router>
      </div>
    </ConfigProvider>
  );
};

export default App;
